var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.joinedSession)?_c('LiveSession'):_c('GuestWelcome',{attrs:{"displayName":_vm.displayName},on:{"joinSession":function($event){return _vm.joinSession()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }